/** Normalise le markdown Gemini avant rendu (sauts de ligne manquants, listes). */
export const normalizeAssistantMarkdown = (text: string): string =>
  text
    .replace(/\r\n/g, '\n')
    .replace(/([^\n])\n(#{1,6}\s)/g, '$1\n\n$2')
    .replace(/([^\n])\n([*-]\s)/g, '$1\n\n$2')
    .trim()
